const footerEl = document.querySelector( '.page-footer' );
const footerNavEl = footerEl.querySelector( '.js-c-menu-footer' );
const backToTop = footerEl.querySelector( '.js-back-to-top' );
const MobileBreakpoint = 767;


/**
 * Footer
 * @description - Footer scripts
 * @function
 * @name footer
 * @return {void}
 */
const footerMenu = () => {

	if ( !footerEl ) {

		return;

	}

	if ( !footerNavEl ) {

		return;

	}

	const footerTriggers = footerNavEl.querySelectorAll( '.js-menu-footer-has-children .js-menu-footer-trigger' );
	footerTriggers.forEach( ( trigger ) => {

		trigger.addEventListener( 'click', ( e ) => {

			e.preventDefault();
			if ( window.innerWidth < MobileBreakpoint ) {

				trigger.classList.toggle( 'is-active' );
				const panel = trigger.nextElementSibling;
				if ( panel.style.maxHeight ) {

					panel.style.maxHeight = null;

				} else {

					panel.style.maxHeight = `${ panel.scrollHeight }px`;

				}
				trigger.nextElementSibling.classList.toggle( 'is-active' );

			}

		} );

	} );

	backToTop.addEventListener( 'click', () => {

		window.scrollTo( {
			top: 0,
			behavior: 'smooth'
		} );

	} );

}

export { footerMenu };
